import React from "react";
import "./Button.scss";

function Button({ text, image }) {
  return (
    <button>
      <div className="button-inner">
        {image && <img src={image} alt="" />}
        <span className="retro">{text}</span>
      </div>
    </button>
  );
}

export default Button;
